
























































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { montarPivot, montarBlocosDeGrade, BlocoGrade, tratarNumero, colunaDoRotuloDeTotal, ordenarChavesDeGrupo, montarLinhasDoExcel } from '@/shareds/dashboard/gerar-relatorio-grid'

export interface FiltroDeColuna {
	field: string
	operador: string
	valor: string
	valor2?: string
}

const OPERADORES_TEXTO = [
	{ valor: 'contem', texto: 'Contém' },
	{ valor: 'naoContem', texto: 'Não contém' },
	{ valor: 'igual', texto: 'Igual' },
	{ valor: 'diferente', texto: 'Diferente de' },
	{ valor: 'comecaCom', texto: 'Começa com' },
	{ valor: 'terminaCom', texto: 'Termina com' },
	{ valor: 'vazio', texto: 'Em branco' },
	{ valor: 'naoVazio', texto: 'Não está em branco' },
]

const OPERADORES_NUMERO = [
	{ valor: 'igual', texto: 'Igual' },
	{ valor: 'diferente', texto: 'Diferente de' },
	{ valor: 'maior', texto: 'Maior que' },
	{ valor: 'maiorIgual', texto: 'Maior ou igual a' },
	{ valor: 'menor', texto: 'Menor que' },
	{ valor: 'menorIgual', texto: 'Menor ou igual a' },
	{ valor: 'entre', texto: 'Entre' },
	{ valor: 'vazio', texto: 'Em branco' },
	{ valor: 'naoVazio', texto: 'Não está em branco' },
]

// Normaliza para comparação: sem acento e sem diferenciar maiúsculas ("Crediário" = "CREDIARIO").
function normalizar(v: any): string {
	return String(v ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().trim()
}

function vazio(v: any): boolean {
	return v === null || v === undefined || String(v).trim() === ''
}

@Component
export default class ConstrutorDeRelatorio extends Vue {
	@Prop({ type: Array, default: () => [] }) colunas!: any[]
	@Prop({ type: Array, default: () => [] }) linhas!: any[]
	@Prop({ type: String, default: '#60269E' }) corPrimaria!: string
	@Prop({ type: String, default: 'Relatório' }) titulo!: string
	@Prop({ type: String, default: '' }) empresa!: string
	@Prop({ type: Array, default: () => [] }) filtros!: any[]
	@Prop({ type: Array, default: () => [] }) templates!: any[]
	@Prop({ type: Boolean, default: false }) podeGlobal!: boolean
	@Prop({ type: String, default: '' }) usuarioId!: string
	@Prop({ type: String, default: null }) quebraPadrao!: string | null
	@Prop({ type: Boolean, default: false }) somenteLeitura!: boolean
	@Prop({ type: Object, default: null }) templateForcado!: any

	readonly PASSO = 300
	readonly PASSO_BLOCOS = 20

	painelAberto = true
	campos: any[] = []
	quebras: any[] = []
	ordenarField: string | null = null
	ordenarDir = 'asc'
	orientacao = 'paisagem'
	subtotais = true
	totalGeral = true
	nomeTemplate = ''
	tornarGlobal = false
	templateSelecionado: any = null
	templateEditando: any = null
	arrastandoIdx = -1

	pivotAtivo = false
	pivotLinhas: any[] = []
	pivotColuna: string | null = null
	pivotValores: any[] = []
	formato = 'tabela'

	filtrosColuna: FiltroDeColuna[] = []
	buscaDigitada: string | null = ''
	busca = ''
	timerBusca: any = null
	limite = 300
	limiteBlocos = 20
	menuFiltro: any = { aberto: false, x: 0, y: 0, field: '', operador: 'contem', valor: '', valor2: '' }

	get painelVisivel(): boolean { return this.painelAberto && !this.somenteLeitura }
	get assinaturaColunas(): string { return this.colunas.map(c => c.field).join('|') }

	@Watch('assinaturaColunas', { immediate: true })
	aoTrocarColunas() { this.reiniciar() }

	@Watch('templateForcado')
	aoTrocarTemplateForcado(t: any) {
		if (!t) return
		this.templateSelecionado = t
		this.carregarTemplate()
	}

	@Watch('linhas')
	aoTrocarLinhas() { this.limite = this.PASSO; this.limiteBlocos = this.PASSO_BLOCOS }

	@Watch('buscaDigitada')
	aoDigitarBusca(v: string | null) {
		clearTimeout(this.timerBusca)
		this.timerBusca = setTimeout(() => { this.busca = v || '' }, 300)
	}

	beforeDestroy() { clearTimeout(this.timerBusca) }

	reiniciar() {
		this.campos = this.colunas.map(c => ({ ...c, incluir: true }))
		this.quebras = this.quebraPadrao && this.colunas.some(c => c.field === this.quebraPadrao) ? [{ field: this.quebraPadrao }] : []
		this.ordenarField = null
		this.ordenarDir = 'asc'
		this.orientacao = 'paisagem'
		this.subtotais = true
		this.totalGeral = true
		this.nomeTemplate = ''
		this.tornarGlobal = false
		this.templateSelecionado = null
		this.templateEditando = null
		this.pivotAtivo = false
		this.pivotLinhas = []
		this.pivotColuna = null
		this.pivotValores = []
		this.formato = 'tabela'
		this.filtrosColuna = []
		this.limite = this.PASSO
		this.limiteBlocos = this.PASSO_BLOCOS
		if (!this.colunas.length) return
		const inicial = this.templateForcado || this.templatePadrao
		if (inicial) {
			this.templateSelecionado = inicial
			this.carregarTemplate()
		}
	}

	ehNumerico(field: string): boolean { const c = this.campos.find(x => x.field === field); return !!(c && c.numerico) }
	operadoresDe(field: string) { return this.ehNumerico(field) ? OPERADORES_NUMERO : OPERADORES_TEXTO }
	operadorPedeValor(op: string): boolean { return op !== 'vazio' && op !== 'naoVazio' }
	textoOperador(f: FiltroDeColuna): string { const op = this.operadoresDe(f.field).find(o => o.valor === f.operador); return op ? op.texto : f.operador }
	dlId(field: string): string { return 'dl-relatorio-' + String(field).replace(/[^\w-]/g, '_') }
	campoExiste(field: string): boolean { return this.campos.some(c => c.field === field) }

	filtroValido(f: FiltroDeColuna): boolean {
		if (!f.field || !f.operador) return false
		if (!this.operadorPedeValor(f.operador)) return true
		if (vazio(f.valor)) return false
		return f.operador !== 'entre' || !vazio(f.valor2)
	}

	get filtrosAtivos(): FiltroDeColuna[] { return this.filtrosColuna.filter(f => this.filtroValido(f)) }

	temFiltro(field: string): boolean { return this.filtrosAtivos.some(f => f.field === field) }

	descreverFiltro(f: FiltroDeColuna): string {
		const base = `${this.headerDe(f.field)} ${this.textoOperador(f).toLowerCase()}`
		if (!this.operadorPedeValor(f.operador)) return base
		return f.operador === 'entre' ? `${base} ${f.valor} e ${f.valor2}` : `${base} "${f.valor}"`
	}

	atende(valorLinha: any, f: FiltroDeColuna): boolean {
		if (f.operador === 'vazio') return vazio(valorLinha)
		if (f.operador === 'naoVazio') return !vazio(valorLinha)
		if (this.ehNumerico(f.field)) {
			if (vazio(valorLinha)) return false
			const n = tratarNumero(valorLinha)
			const a = tratarNumero(f.valor)
			switch (f.operador) {
				case 'igual': return n === a
				case 'diferente': return n !== a
				case 'maior': return n > a
				case 'maiorIgual': return n >= a
				case 'menor': return n < a
				case 'menorIgual': return n <= a
				case 'entre': { const b = tratarNumero(f.valor2); return n >= Math.min(a, b) && n <= Math.max(a, b) }
				default: return true
			}
		}
		const v = normalizar(valorLinha)
		const alvo = normalizar(f.valor)
		switch (f.operador) {
			case 'contem': return v.includes(alvo)
			case 'naoContem': return !v.includes(alvo)
			case 'igual': return v === alvo
			case 'diferente': return v !== alvo
			case 'comecaCom': return v.startsWith(alvo)
			case 'terminaCom': return v.endsWith(alvo)
			default: return true
		}
	}

	get linhasFiltradas(): any[] {
		const filtros = this.filtrosAtivos
		const busca = normalizar(this.busca)
		if (!filtros.length && !busca) return this.linhas || []
		const fields = this.campos.map(c => c.field)
		return (this.linhas || []).filter(r =>
			filtros.every(f => this.atende(r[f.field], f))
			&& (!busca || fields.some(field => normalizar(r[field]).includes(busca))),
		)
	}

	adicionarFiltro() { this.filtrosColuna.push({ field: '', operador: 'contem', valor: '', valor2: '' }) }
	removerFiltro(i: number) { this.filtrosColuna.splice(i, 1) }
	removerFiltroAtivo(f: FiltroDeColuna) { const i = this.filtrosColuna.indexOf(f); if (i >= 0) this.filtrosColuna.splice(i, 1) }
	limparFiltros() { this.filtrosColuna = [] }
	aoTrocarCampoDoFiltro(f: FiltroDeColuna) {
		if (!this.operadoresDe(f.field).some(o => o.valor === f.operador)) f.operador = this.operadoresDe(f.field)[0].valor
	}

	abrirMenuFiltro(e: MouseEvent, field: string) {
		const atual = this.filtrosColuna.find(f => f.field === field)
		const ops = this.operadoresDe(field)
		this.menuFiltro = {
			aberto: false,
			x: e.clientX,
			y: e.clientY,
			field,
			operador: atual ? atual.operador : ops[0].valor,
			valor: atual ? atual.valor : '',
			valor2: atual ? atual.valor2 || '' : '',
		}
		this.$nextTick(() => { this.menuFiltro.aberto = true })
	}

	aplicarMenuFiltro() {
		const m = this.menuFiltro
		const novo: FiltroDeColuna = { field: m.field, operador: m.operador, valor: m.valor, valor2: m.valor2 }
		const i = this.filtrosColuna.findIndex(f => f.field === m.field)
		if (i >= 0) this.filtrosColuna.splice(i, 1, novo)
		else this.filtrosColuna.push(novo)
		this.menuFiltro.aberto = false
	}

	limparMenuFiltro() {
		this.filtrosColuna = this.filtrosColuna.filter(f => f.field !== this.menuFiltro.field)
		this.menuFiltro.aberto = false
	}

	get camposComDatalist(): string[] {
		const fields = this.filtrosColuna.map(f => f.field)
		if (this.menuFiltro.field) fields.push(this.menuFiltro.field)
		return Array.from(new Set(fields)).filter(f => f && !this.ehNumerico(f))
	}

	valoresDistintos(field: string): string[] {
		const set = new Set<string>()
		for (const r of this.linhas || []) {
			const v = r[field]
			if (!vazio(v)) set.add(String(v))
			if (set.size >= 200) break
		}
		return Array.from(set).sort((a, b) => a.localeCompare(b, 'pt-BR'))
	}

	get chipsCabecalho(): any[] {
		return [...this.filtros, ...this.filtrosAtivos.map(f => ({ label: 'Filtro', valor: this.descreverFiltro(f) }))]
	}

	get camposPivotTodos(): any[] { return this.campos.filter(c => c.incluir) }
	get camposPivotValores(): any[] { return this.campos.filter(c => c.incluir && c.numerico) }
	get pivotLinhasFields(): string[] {
		const vistos = new Set<string>()
		return this.pivotLinhas.map((l: any) => l.field).filter((f: string) => f && !vistos.has(f) && vistos.add(f))
	}
	get pivotValoresFields(): string[] {
		const vistos = new Set<string>()
		return this.pivotValores.map((v: any) => v.field).filter((f: string) => f && !vistos.has(f) && vistos.add(f))
	}
	adicionarLinha() { this.pivotLinhas.push({ field: '' }) }
	removerLinha(i: number) { this.pivotLinhas.splice(i, 1) }
	adicionarValor() { this.pivotValores.push({ field: '' }) }
	removerValor(i: number) { this.pivotValores.splice(i, 1) }
	get pivotValido(): boolean { return this.pivotAtivo && this.pivotLinhasFields.length > 0 && !!this.pivotColuna && this.pivotValoresFields.length > 0 }
	get pivotConfig(): any {
		if (!this.pivotValido) return null
		return {
			colunaField: this.pivotColuna,
			linhas: this.pivotLinhasFields.map(f => ({ field: f, header: this.headerDe(f) })),
			valores: this.pivotValoresFields.map(f => {
				const c = this.campos.find(x => x.field === f)
				return { field: f, header: this.headerDe(f), moeda: !!(c && c.moeda) }
			}),
		}
	}
	get dadosPivot(): { colunas: any[]; linhas: any[] } {
		if (!this.pivotValido) return { colunas: [], linhas: [] }
		return montarPivot(this.linhasOrdenadas, this.pivotConfig)
	}
	get ehBlocos(): boolean { return this.pivotAtivo && this.formato === 'blocos' }
	get imagemField(): string | null {
		const c = this.campos.find(c => c.incluir && /(imagem|foto|img|thumb|avatar)/i.test((c.header || '') + ' ' + (c.field || '')))
		return c ? c.field : null
	}
	get blocoConfig(): any {
		if (!this.pivotValido) return null
		return {
			idFields: this.pivotLinhasFields.map(f => ({ field: f, header: this.headerDe(f) })),
			colunaField: this.pivotColuna,
			metricas: this.pivotValoresFields.map(f => {
				const c = this.campos.find(x => x.field === f)
				return { field: f, header: this.headerDe(f), moeda: !!(c && c.moeda) }
			}),
			imagemField: this.imagemField,
		}
	}
	get todosOsBlocos(): BlocoGrade[] {
		if (!this.ehBlocos || !this.blocoConfig) return []
		return montarBlocosDeGrade(this.linhasOrdenadas, this.blocoConfig)
	}
	get totalBlocos(): number { return this.todosOsBlocos.length }
	get blocosVisiveis(): BlocoGrade[] { return this.todosOsBlocos.slice(0, this.limiteBlocos) }
	fmtNum(v: number, moeda: boolean): string {
		if (v === null || v === undefined) return ''
		if (moeda) return 'R$ ' + this.toNum(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
		return this.toNum(v).toLocaleString('pt-BR')
	}
	get pivotQtdColunas(): number { return this.pivotValido ? Math.max(0, this.dadosPivot.colunas.length - 1) : 0 }
	get cabecalhoGrupos(): any[] {
		const grupos: any[] = []
		this.previewColunas.forEach((c: any) => {
			const g = c.grupo || null
			const last = grupos[grupos.length - 1]
			if (last && last.nome === g && g !== null) last.cols.push(c)
			else grupos.push({ nome: g, cols: [c] })
		})
		return grupos
	}

	get corClara(): string { return this.clarear(this.corPrimaria, 0.9) }
	clarear(hex: string, fator: number): string {
		const h = (hex || '').replace('#', '')
		if (h.length !== 6) return '#EEEDFE'
		const n = [0, 2, 4].map(i => parseInt(h.slice(i, i + 2), 16))
		const mix = (c: number) => Math.round(c + (255 - c) * fator)
		return `#${n.map(c => mix(c).toString(16).padStart(2, '0')).join('')}`
	}
	escurecer(hex: string, fator: number): string {
		const h = (hex || '').replace('#', '')
		if (h.length !== 6) return '#2a1a4a'
		const n = [0, 2, 4].map(i => parseInt(h.slice(i, i + 2), 16))
		const mix = (c: number) => Math.round(c * (1 - fator))
		return `#${n.map(c => mix(c).toString(16).padStart(2, '0')).join('')}`
	}
	get gradiente(): string { return `linear-gradient(135deg, ${this.escurecer(this.corPrimaria, 0.5)} 0%, ${this.corPrimaria} 100%)` }
	get geradoEm(): string { return new Date().toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' }) }

	get opcoesQuebra(): any[] { return this.campos.filter(c => c.incluir) }
	get quebraFields(): string[] { return this.pivotValido ? [] : this.quebras.map((q: any) => q.field).filter(Boolean) }
	get previewColunas(): any[] {
		if (this.pivotValido) return this.dadosPivot.colunas
		return this.campos.filter(c => c.incluir && !this.quebraFields.includes(c.field))
	}
	get temTotais(): boolean { return this.previewColunas.some(c => c.aggFunc) }
	headerDe(f: string): string { const c = this.campos.find(x => x.field === f); return c ? c.header : f }
	adicionarQuebra() { this.quebras.push({ field: '' }) }
	removerQuebra(i: number) { this.quebras.splice(i, 1) }
	alternarOrdenacao(field: string) {
		if (this.ordenarField !== field) { this.ordenarField = field; this.ordenarDir = 'asc' }
		else if (this.ordenarDir === 'asc') this.ordenarDir = 'desc'
		else this.ordenarField = null
	}

	get editandoProprio(): boolean { const t = this.templateEditando; return !!t && (!t.global || t.usuarioId === this.usuarioId) }
	get podeRemoverSelecionado(): boolean { const t = this.templateSelecionado; return !!t && (!t.global || t.usuarioId === this.usuarioId) }
	get ehPadrao(): boolean { const t = this.templateSelecionado; return !!t && !!t.favorito && t.usuarioId === this.usuarioId }
	get podeFavoritar(): boolean { const t = this.templateSelecionado; return !!t && t.usuarioId === this.usuarioId }
	get templatePadrao(): any {
		const list = this.templates || []
		if (!list.length) return null
		return list.find((t: any) => t.favorito && t.usuarioId === this.usuarioId)
			|| list.find((t: any) => t.global && !t.visaoLegada)
			|| list.find((t: any) => !t.visaoLegada)
			|| null
	}
	alternarPadrao() {
		if (!this.templateSelecionado || !this.podeFavoritar) return
		const novo = !this.ehPadrao
		this.$set(this.templateSelecionado, 'favorito', novo)
		this.$emit('marcar-padrao', { presetId: this.templateSelecionado.id, favorito: novo })
	}
	alternarCompartilhar() {
		if (!this.templateSelecionado || !this.podeGlobal) return
		const t = this.templateSelecionado
		const novoGlobal = !t.global
		const config = (t.presetSalvo && (t.presetSalvo.config || t.presetSalvo)) || this.configAtual()
		this.$emit('salvar-template', { id: t.id, nome: t.nome, global: novoGlobal, config })
		this.$set(t, 'global', novoGlobal)
		this.tornarGlobal = novoGlobal
	}

	chipTexto(c: any): string { return c.moeda ? 'R$' : (c.numerico ? '#' : 'Aa') }
	chipEstilo(c: any): any {
		if (c.moeda) return { background: '#E1F5EE', color: '#0F6E56' }
		if (c.numerico) return { background: '#E6F1FB', color: '#0C447C' }
		return { background: '#EEEDFE', color: '#3C3489' }
	}

	toNum(v: any): number { const n = Number(v); return isNaN(n) ? 0 : n }
	fmtVal(v: any, col: any): string {
		if (v === null || v === undefined || v === '') return ''
		if (col.moeda) return 'R$ ' + this.toNum(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
		if (col.numerico) { const n = Number(v); return isNaN(n) ? String(v) : n.toLocaleString('pt-BR') }
		return String(v)
	}
	ehImagem(v: any, col: any): boolean {
		if (typeof v !== 'string') return false
		const s = v.trim()
		if (!/^https?:\/\//i.test(s) && !/^data:image\//i.test(s)) return false
		const dica = /(imagem|image|foto|img|logo|thumb|avatar)/.test(((col.header || '') + ' ' + (col.field || '')).toLowerCase())
		const ext = /\.(png|jpe?g|gif|webp|bmp|svg)(\?|#|$)/i.test(s)
		return dica || ext
	}
	agregar(itens: any[], col: any): number | null {
		if (!col.aggFunc) return null
		const nums = itens.map(i => Number(i[col.field])).filter(n => !isNaN(n))
		switch (col.aggFunc) {
			case 'sum': return nums.reduce((a, b) => a + b, 0)
			case 'avg': return nums.length ? nums.reduce((a, b) => a + b, 0) / nums.length : 0
			case 'min': return nums.length ? Math.min(...nums) : 0
			case 'max': return nums.length ? Math.max(...nums) : 0
			case 'count': return itens.length
			default: return null
		}
	}
	celTotal(itens: any[], col: any): string {
		const r = this.agregar(itens, col)
		if (r === null) return ''
		return col.aggFunc === 'count' ? String(r) : this.fmtVal(r, col)
	}
	get colunaDoRotulo(): number { return colunaDoRotuloDeTotal(this.previewColunas) }
	celulaDeTotal(itens: any[], col: any, i: number, rotulo: string): string {
		if (i === this.colunaDoRotulo) return rotulo
		const valor = this.celTotal(itens, col)
		return this.colunaDoRotulo < 0 && i === 0 ? `${rotulo}: ${valor}` : valor
	}

	get linhasOrdenadas(): any[] {
		const base = this.linhasFiltradas.slice()
		if (this.ordenarField) {
			const f = this.ordenarField
			base.sort((a, b) => {
				const x = a[f]; const y = b[f]
				let r: number
				if (typeof x === 'number' && typeof y === 'number') r = x - y
				else r = String(x ?? '').localeCompare(String(y ?? ''), 'pt-BR', { numeric: true })
				return this.ordenarDir === 'desc' ? -r : r
			})
		}
		return base
	}
	get linhasEfetivas(): any[] {
		return this.pivotValido ? this.dadosPivot.linhas : this.linhasOrdenadas
	}
	get linhasRender(): any[] {
		if (this.pivotValido) return this.dadosPivot.linhas.map((r: any) => ({ tipo: 'data', row: r }))
		const out: any[] = []
		const fields = this.quebraFields
		const build = (rows: any[], lvl: number) => {
			if (lvl >= fields.length) { rows.forEach(r => out.push({ tipo: 'data', row: r })); return }
			const f = fields[lvl]
			const map = new Map<string, any[]>()
			rows.forEach(r => { const k = String(r[f] ?? '—'); if (!map.has(k)) map.set(k, []); map.get(k)!.push(r) })
			const chaves = ordenarChavesDeGrupo(Array.from(map.keys()), this.ordenarField === f && this.ordenarDir === 'desc')
			chaves.forEach(chave => {
				const itens = map.get(chave)!
				out.push({ tipo: 'grupo', level: lvl, header: this.headerDe(f), chave, count: itens.length })
				build(itens, lvl + 1)
				if (this.subtotais) out.push({ tipo: 'sub', level: lvl, chave, itens })
			})
		}
		build(this.linhasOrdenadas, 0)
		return out
	}
	get linhasVisiveis(): any[] { return this.linhasRender.slice(0, this.limite) }

	onDragStart(i: number) { this.arrastandoIdx = i }
	onDrop(i: number) {
		if (this.arrastandoIdx < 0 || this.arrastandoIdx === i) return
		const arr = this.campos.slice()
		const [m] = arr.splice(this.arrastandoIdx, 1)
		arr.splice(i, 0, m)
		this.campos = arr
		this.arrastandoIdx = -1
	}

	configAtual(): any {
		return {
			tipo: 'relatorio-pdf',
			ordem: this.campos.filter(c => c.incluir).map(c => c.field),
			quebraFields: this.quebraFields,
			ordenarField: this.ordenarField,
			ordenarDir: this.ordenarDir,
			orientacao: this.orientacao,
			subtotais: this.subtotais,
			totalGeral: this.totalGeral,
			pivot: this.pivotConfig,
			formato: this.ehBlocos ? 'blocos' : 'tabela',
			filtros: this.filtrosAtivos.map(f => ({ ...f })),
		}
	}
	carregarTemplate() {
		const t = this.templateSelecionado
		const cfg = t && t.presetSalvo ? (t.presetSalvo.config || t.presetSalvo) : null
		if (!cfg) { this.templateEditando = null; return }
		const ordem: string[] = cfg.ordem || []
		const ocultos: string[] = cfg.ocultos || []
		this.campos.forEach(c => { c.incluir = ordem.length ? ordem.includes(c.field) : !ocultos.includes(c.field) })
		if (ordem.length) {
			const incluidos = ordem.map(f => this.campos.find(c => c.field === f)).filter(Boolean) as any[]
			const resto = this.campos.filter(c => !ordem.includes(c.field))
			this.campos = [...incluidos, ...resto]
		}
		const qf: string[] = cfg.quebraFields || (cfg.quebraField ? [cfg.quebraField] : [])
		this.quebras = qf.map(field => ({ field }))
		this.ordenarField = cfg.ordenarField ?? null
		this.ordenarDir = cfg.ordenarDir ?? 'asc'
		this.orientacao = cfg.orientacao ?? 'paisagem'
		this.subtotais = cfg.subtotais ?? true
		this.totalGeral = cfg.totalGeral ?? true
		const pv = cfg.pivot
		const valoresPv = pv ? (pv.valores ? pv.valores.map((v: any) => v.field) : (pv.valorField ? [pv.valorField] : [])) : []
		const linhasPv = pv ? (pv.linhas ? pv.linhas.map((l: any) => l.field) : (pv.linhaField ? [pv.linhaField] : [])) : []
		if (pv && linhasPv.length && pv.colunaField && valoresPv.length) {
			this.pivotAtivo = true
			this.pivotLinhas = linhasPv.map((f: string) => ({ field: f }))
			this.pivotColuna = pv.colunaField
			this.pivotValores = valoresPv.map((f: string) => ({ field: f }))
			this.formato = cfg.formato === 'blocos' ? 'blocos' : 'tabela'
		} else {
			this.pivotAtivo = false
			this.pivotLinhas = []
			this.pivotColuna = null
			this.pivotValores = []
			this.formato = 'tabela'
		}
		this.filtrosColuna = (cfg.filtros || [])
			.filter((f: any) => this.campoExiste(f.field))
			.map((f: any) => ({ field: f.field, operador: f.operador, valor: f.valor ?? '', valor2: f.valor2 ?? '' }))
		this.templateEditando = t
		this.nomeTemplate = t.nome
		this.tornarGlobal = !!t.global
	}
	salvarTemplate(comoNovo = false) {
		const atualizando = !comoNovo && this.editandoProprio
		this.$emit('salvar-template', {
			id: atualizando ? this.templateEditando.id : null,
			nome: this.nomeTemplate.trim(),
			global: this.tornarGlobal && this.podeGlobal,
			config: this.configAtual(),
		})
		if (!atualizando) { this.nomeTemplate = ''; this.tornarGlobal = false; this.templateEditando = null }
	}
	removerTemplate() {
		if (!this.templateSelecionado || !this.podeRemoverSelecionado) return
		this.$emit('remover-template', this.templateSelecionado.id)
		this.templateSelecionado = null
	}

	gerar() {
		const colunas = this.previewColunas.map(c => ({ header: c.header, field: c.field, numerico: c.numerico, moeda: c.moeda, aggFunc: c.aggFunc }))
		this.$emit('gerar', {
			colunas, quebraFields: this.quebraFields, ordenarField: this.ordenarField, ordenarDir: this.ordenarDir,
			orientacao: this.orientacao, subtotais: this.subtotais, totalGeral: this.totalGeral,
			pivot: this.pivotConfig,
			formato: this.ehBlocos ? 'blocos' : 'tabela',
			imagemField: this.imagemField,
			linhas: this.linhasOrdenadas,
			filtros: this.chipsCabecalho,
		})
	}

	exportarExcel() {
		const colunas = this.pivotValido
			? this.dadosPivot.colunas
			: [...this.quebraFields.map(f => this.campos.find(c => c.field === f)).filter(Boolean), ...this.previewColunas]
		// Com quebras, segue a mesma ordem agrupada da pré-visualização (linhasRender), não a ordem crua.
		const linhas = this.pivotValido
			? this.linhasEfetivas
			: this.linhasRender.filter((r: any) => r.tipo === 'data').map((r: any) => r.row)
		// Com "Subtotais por quebra", cada grupo fecha com o seu subtotal, como no PDF.
		const corpo = montarLinhasDoExcel(this.linhasRender, colunas, this.quebraFields)
		import('xlsx').then(XLSX => {
			const wsData: any[][] = [
				colunas.map((c: any) => c.header),
				...corpo.map(l => l.valores),
			]
			if (this.totalGeral && colunas.some((c: any) => c.aggFunc)) {
				const iRotulo = colunaDoRotuloDeTotal(colunas)
				wsData.push(colunas.map((c: any, i: number) => i === iRotulo ? 'Total geral' : (this.agregar(linhas, c) ?? '')))
			}
			const ws = XLSX.utils.aoa_to_sheet(wsData)
			// Agrupamento de linhas do próprio Excel: recolhendo os grupos, sobram os subtotais.
			if (corpo.some(l => l.nivel)) ws['!rows'] = [{}, ...corpo.map(l => ({ level: l.nivel }))]
			const wb = XLSX.utils.book_new()
			const nome = (this.titulo || 'Relatório').replace(/[\\/?*[\]:]/g, ' ')
			XLSX.utils.book_append_sheet(wb, ws, nome.slice(0, 31))
			XLSX.writeFile(wb, `${nome}.xlsx`)
		})
	}
}
